import React from 'react'
import { IMatch } from 'protos'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'
import MatchStatusSwitch from 'components/MatchStatusSwitch'
import { FormattedTime } from 'react-intl'

interface MatchProps {
  match: IMatch
}

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium
    },
    team: {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      color: theme.palette.text.primary,
    },
    status: {
      opacity: .3,
      fontSize: 'inherit',
      fontWeight: 'inherit',
    }
  })
}

type InjectedProps = MatchProps & WithStyles<typeof styles>

const Match: React.SFC<InjectedProps> = ({ match, classes, ...props }) => {
  const { name: homeName } = match.homeTeam!
  const { name: awayName } = match.awayTeam!

  return (
    <Grid container direction="row" alignItems="center" spacing={1} className={classes.root}>
      <Grid item xs={4} sm={5}>
        <Typography align="right" variant="h3" title={homeName + ''} className={classes.team} noWrap>
          {homeName}
        </Typography>
      </Grid>
      <Grid item xs>
        <Typography align="center" className={classes.status}>
          <MatchStatusSwitch
            status={match.status}
            renderPreMatch={() => (
              match.kickoff ? <FormattedTime value={Number(match.kickoff) * 1000} /> : <span>vs</span>
            )}
            renderDuringMatch={() => <span>{match.currentScore || '0 - 0'}</span>}
            renderPostMatch={() => <span>{match.currentScore || ' 0 - 0'}</span>}
          />
        </Typography>
      </Grid>
      <Grid item xs={4} sm={5}>
        <Typography align="left" variant="h3" title={awayName + ''} className={classes.team} noWrap>
          {awayName}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Match)
